module.exports = __webpack_public_path__ + "img/GAME_SWEEPLEAVES1.7545e3ed.jpg";